module.exports = __webpack_public_path__ + "static/media/AashitaNarula.965258b0.png";